import React from "react";
import PropTypes from "prop-types";

import { useSelector } from "react-redux";
import { getUserAge, getUserId } from "domain/User/selectors";
import { getIsParticipate } from "domain/Game/selectors";

const AnnotationAgeLimit = ({ ageLimit, id, organizer }) => {
    const userId = useSelector((state) => getUserId(state));
    const isParticipate = useSelector((state) =>
        getIsParticipate(state, id, userId)
    );
    const isOrganizer = organizer.id === userId;
    const userAge = useSelector((state) => getUserAge(state));
    const show =
        ageLimit &&
        typeof userAge === "number" &&
        userAge < 18 &&
        !isParticipate &&
        !isOrganizer;

    if (show) {
        return (
            <p className="c-gs-disabled">
                Организатор ограничил запись для несовершеннолетних
            </p>
        );
    }

    return null;
};

AnnotationAgeLimit.propTypes = {
    ageLimit: PropTypes.bool,
    id: PropTypes.string,
    organizer: PropTypes.object,
};

export default AnnotationAgeLimit;
